import { mdiFileDocument } from '@mdi/js';
import { Icon } from '@mdi/react';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { ClaimResponsibilityType } from '../../api';
import { formatDate, formatNumber } from '../../services';
import { getResponsibilityDescription, ResponsibilityBadge } from '../badge';
import { Tooltip } from '../base';
import * as S from './claim-search-result.styles';
import {ClaimId} from "./claim-search-result.styles";

export interface IClaimSearchResultProps {
    id?: string;
    fromDos?: string;
    throughDos?: string;
    claimResponsibilityType?: keyof typeof ClaimResponsibilityType;
    primaryPayerName?: string;
    charge?: string;
    externalId?: string;
    onClick?: () => void;
    selected?: boolean;
    disableNavigation?: boolean;
}

export const ClaimSearchResult: React.FC<IClaimSearchResultProps> = ({
    id,
    externalId,
    fromDos,
    throughDos,
    claimResponsibilityType,
    primaryPayerName,
    charge,
    selected,
    disableNavigation,
    onClick,
}) => {
    const fmtNumber = formatNumber('Currency');
    const fmtDate = formatDate('MonthDay');
    const total = charge ? Number.parseFloat(charge) : Number.NaN;
    const from = fromDos ? fmtDate(fromDos) : undefined;
    const through = throughDos ? fmtDate(throughDos) : undefined;
    const serviceDate = through && from !== through ? `${from} – ${through}` : from;
    const claimExternalId = externalId ? (externalId.length > 20 ? externalId.substr(0, 18) + "..." : externalId) : '-';

    const history = useHistory();

    const claimLink = history.createHref({ pathname: `/claims/${id}` });

    const handleClick = () => {
        onClick?.();
    };

    return (
        <S.Claim onClick={handleClick} selected={selected}>
            <S.ClaimIcon>
                <S.ClaimLink href={disableNavigation ? undefined : claimLink}>
                    <Icon path={mdiFileDocument} size={1} />
                </S.ClaimLink>
            </S.ClaimIcon>
            <S.ClaimServiceDate>
                <S.ClaimLink href={disableNavigation ? undefined : claimLink}>{serviceDate}</S.ClaimLink>
            </S.ClaimServiceDate>
            <S.ClaimId>
                <S.ClaimLink href={disableNavigation ? undefined : claimLink}>{claimExternalId}</S.ClaimLink>
            </S.ClaimId>
            <S.ClaimStatus>
                <S.ClaimLink href={disableNavigation ? undefined : claimLink}>
                    <Tooltip
                        direction="top"
                        variant="dark"
                        title={
                            claimResponsibilityType ? (
                                <span>
                                    {getResponsibilityDescription(ClaimResponsibilityType[claimResponsibilityType])}
                                </span>
                            ) : undefined
                        }>
                        <div>
                            <ResponsibilityBadge
                                size="small"
                                responsibility={
                                    claimResponsibilityType
                                        ? ClaimResponsibilityType[claimResponsibilityType]
                                        : claimResponsibilityType
                                }
                            />
                        </div>
                    </Tooltip>
                </S.ClaimLink>
            </S.ClaimStatus>
            <S.ClaimPayer>
                <S.ClaimLink href={disableNavigation ? undefined : claimLink}>{primaryPayerName}</S.ClaimLink>
            </S.ClaimPayer>
            {!Number.isNaN(total) && (
                <S.ClaimTotal>
                    <S.ClaimLink href={disableNavigation ? undefined : claimLink}>{fmtNumber(total)}</S.ClaimLink>
                </S.ClaimTotal>
            )}
        </S.Claim>
    );
};
